var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlantIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.62533V5.66667C14.5 4.42899 15.0268 3.242 15.9645 2.36683C16.9021 1.49166 18.1739 1 19.5 1H21.375C21.5408 1 21.6997 1.06146 21.8169 1.17085C21.9342 1.28025 22 1.42862 22 1.58333V3.33333C22 4.57101 21.4732 5.758 20.5355 6.63316C19.5979 7.50833 18.3261 8 17 8C15.6739 8 14.4021 8.49166 13.4645 9.36683C12.5268 10.242 12 11.429 12 12.6667C12 15 13.25 16.1667 13.25 18.5C13.25 19.7622 12.8114 20.9903 12 22",
    stroke: "#4D4941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76953 8.19362C2.71949 7.52208 3.84908 7.11315 5.03173 7.01264C6.21438 6.91212 7.40336 7.124 8.46545 7.62454C9.52754 8.12507 10.4208 8.89448 11.045 9.84654C11.6693 10.7986 12 11.8957 12 13.015C11.05 13.6865 9.92043 14.0954 8.73778 14.1959C7.55513 14.2964 6.36615 14.0846 5.30407 13.584C4.24198 13.0835 3.34875 12.3141 2.72448 11.362C2.1002 10.41 1.76953 9.31284 1.76953 8.19362Z",
    stroke: "#4D4941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 23C2 23 8.07528 22 12 22C15.9247 22 22 23 22 23",
    stroke: "#4D4941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantIcon);
export default __webpack_public_path__ + "static/media/PlantIcon.a4c759e18a0209f7ea959966021d8644.svg";
export { ForwardRef as ReactComponent };